module.exports = __webpack_public_path__ + "img/status-blue.d9e1419d.svg";